module.exports = __webpack_public_path__ + "static/media/team3.77586e8a.webp";